document.querySelectorAll('dialog.close').forEach(modal => {
    let closeButton = document.createElement('span');
    closeButton.addClass('close');
    closeButton.innerHTML = '&times;';
    closeButton.addEventListener('click', () => {
        modal.close();
    });

    modal.querySelector('div.head')?.append(closeButton);
})

document.querySelectorAll('dialog:not(.close)').forEach(modal => {
    modal.addEventListener('cancel', (e) => {
        e.preventDefault();
    });

    modal.addEventListener('keydown', (e) => {
        if (event.key === 'Escape') {
            e.preventDefault();
        }
    });
})

export function openModal(modalName) {
    const modal = document.querySelector(`dialog[data-name="${modalName}"]`);
    modal.showModal();
}

function closeModal(modalName) {
    const modal = document.querySelector(`dialog[data-name="${modalName}"]`);
    modal.close();
}

document.querySelectorAll('dialog:has(form)').forEach(modal => {
    modal.addEventListener('close', () => {
        const form = modal.querySelector('form');
        setTimeout(() => {
            form.unmarkInvalid();
            form.reset();
            form.querySelectorAll('input.trigger-on-change').forEach((input) => {
                input.trigger('change');
            })
        }, 300);
    })
})

document.querySelectorAll('dialog form.ajaxTableForm').forEach(form => {
    form.addEventListener('submit', () => {
        const ajax = form.dataset.action;
        if (form.validateForm()) {
            post(ajax + '.php', form).then(resp => {
                if (DEBUG) console.log(resp);
                if (resp.status === 'errorModal') {
                    showInfoModal(resp.title, resp.msg);
                } else if (resp.status) {
                    const modal = form.closest('dialog');
                    const list = modal.dataset.list;
                    modal.close();
                    ajaxTableLoad(list);
                }
            })
        }
    })
})

document.querySelectorAll('.modal-opener').forEach(button => {
    const modalName = button.dataset.modal;
    const modal = document.querySelector(`dialog[data-name="${modalName}"]`);
    button.addEventListener('click', () => {
        modal.showModal();
    })
})

document.querySelectorAll('dialog').forEach(modal => {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open') {
                if (modal.hasAttribute('open')) {
                    const event = new CustomEvent('open', {
                        bubbles: false
                    });
                    modal.dispatchEvent(event);
                }
            }
        });
    });

    observer.observe(modal, {attributes: true});
})

export function infoModal(name, msg) {
    let modal = document.querySelector('dialog.info')

    if (modal) {
        modal.querySelector('div.head div').innerHTML = name;
        modal.querySelector('div.body').innerHTML = msg;
        modal.showModal();
    } else {
        modal = document.createElement('dialog');
        modal.addClass('info');
        let head = document.createElement('div');
        head.addClass('head');
        let title = document.createElement('div');
        title.innerHTML = name;
        let closeButton = document.createElement('span');
        closeButton.innerHTML = '&times;';
        closeButton.addEventListener('click', () => {
            modal.close();
        });
        head.append(title)
        head.append(closeButton);
        let body = document.createElement('div');
        body.addClass('body');
        body.innerHTML = msg;

        modal.append(head);
        modal.append(body);
        document.body.append(modal);

        modal.showModal();
    }
}

export function questionModal(name, msg, style = 'info', yesLabel = 'Yes', noLabel = 'No') {
    let modal = document.querySelector('dialog.question');

    if (modal) {
        modal.querySelector('div.head div').innerHTML = name;
        modal.querySelector('div.body').innerHTML = msg;
        modal.showModal();
    } else {
        modal = document.createElement('dialog');
        modal.addClass('question');
        modal.addClass(style);
        let head = document.createElement('div');
        head.addClass('head');
        let title = document.createElement('div');
        title.innerHTML = name;
        head.append(title)
        let body = document.createElement('div');
        body.addClass('body');
        body.innerHTML = msg;
        let footer = document.createElement('div');
        footer.addClass('footer');
        let buttonNo = document.createElement('button');
        buttonNo.innerHTML = noLabel;
        buttonNo.addClass('inactive');
        let buttonYes = document.createElement('button');
        buttonYes.innerHTML = yesLabel;
        buttonYes.addClass(style);
        footer.append(buttonNo);
        footer.append(buttonYes);

        modal.append(head);
        modal.append(body);
        modal.append(footer);
        document.body.append(modal);

        modal.showModal();
    }

    return new Promise((resolve) => {
        let buttonNo = modal.querySelector('div.footer button:first-child');
        let buttonYes = modal.querySelector('div.footer button:last-child');
        const response = (answer) => {
            modal.close();
            buttonYes.removeEventListener('click', clickYes);
            buttonNo.removeEventListener('click', clickNo);
            resolve(answer);
        };
        const clickYes = () => response(true);
        const clickNo = () => response(false);

        buttonYes.addEventListener('click', clickYes);
        buttonNo.addEventListener('click', clickNo);
    });
}